import * as React from 'react'
import { UpgradeWorkspaceMainConnected } from './UpgradeWorkspaceMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const UpgradeWorkspaceMainExamples = () => {
  return (
    <div className="UpgradeWorkspaceMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <UpgradeWorkspaceMainConnected />
      </Provider>
    </div>
  )
}
